module.exports = {
  gotoPhoto: function(photo_id, photoset_id, ajax) {
    var tmpHeight = $('#medium_image_container').height();
    var tmpImg = $("<img src='/images/prettyLoader/ajax-loader.gif' style='margin-top:50px;' border='none'/>");
    $('#show-photo img:first').replaceWith(tmpImg);

    if(navigator.appName.indexOf("Microsoft") == -1) {
      $('#show-photo').html('<div></div>').css('background-color', '#F7F7F7')
      .css('border', 'solid 1px #CCC').append(tmpImg).height(tmpHeight);
    }
    $.get('/photos/show/' + photo_id, {photoset_id: photoset_id, ajax: ajax}, function(data) {
      if(data != null) {
        $('#show_photo').html(data);
      }
    });
    //$('#comment_container').load('/photo/comments/' + photo_id);
    return false;
  },

  getPage: function(url, page) {
    $.prettyLoader.show();
    var index = page - 1;
    var dest = $('#photo_previewer table:eq(' + index.toString() + ')');
    $.get(url, {}, function(data) {
      $.prettyLoader.hide();
      if(data != null) {
        var placeHolder = $(data).find('table:first');
        $('#tempholder').append(placeHolder); //add to dom, get sizes set

        dest.replaceWith(placeHolder);
        $('#wrapper').trigger('goto', [index]);
        var numImg = placeHolder.find('img').length;
        var numRows = Math.ceil((parseFloat(numImg) / 5.0));
        var newHeight = placeHolder.height();
        if(3 - numRows > 0) {
          var rowHeight = placeHolder.find('tr:first').height();
          newHeight = numRows * rowHeight + numRows * 30; //the multiple of 30 is for padding
        }
        $('#paging_links').html($(data).find('#paging_links').html());
        $('#wrapper').animate({height:newHeight}, 300);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./public/javascripts/photosets.js